import { owaComputedFn } from 'owa-computed-fn';
import type { MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import type { ClientItemId } from 'owa-client-ids';
import { getMailRibbonConfigStore } from 'owa-mail-ribbon-store/lib/store/store';
import { getDefaultMLRGroupControls } from './getDefaultMLRGroupControls';
import type { ReadOnlyRibbonControlDefProps } from './RibbonControlDefinitionProps';

export const isMLRGroupCustomized: (
    groupId: RibbonGroupId,
    tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
) => boolean = owaComputedFn(function isMLRGroupCustomized(
    groupId: RibbonGroupId,
    tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
): boolean {
    const controlIds = getMailRibbonConfigStore().multiline.homeTab.layout.find(
        g => g.groupId === groupId
    )?.controlIds;
    const defaultControlIds = getDefaultMLRGroupControls(groupId, tabId, props);

    if (
        !controlIds || //default group has been removed from the stored ribbon
        controlIds.length !== defaultControlIds.length || // number of controls in the stored group differs from the default
        !controlIds.every((id, index) => id === defaultControlIds[index]) // order of controls differs from the default
    ) {
        return true;
    }
    return false;
});

export const getCustomizedLayoutForGroup = (
    _groupId: RibbonGroupId,
    _props: ReadOnlyRibbonControlDefProps,
    _itemId: ClientItemId | undefined
) => {
    return undefined; // TODO: implement this function to return the customized layout for the given group based on the ribbon store's layout for that group
};
